import { SET_CURRENT_USER, USER_LOADING, EDIT_USER } from "../actions/types";

const isEmpty = require("is-empty");
const initialState = {
  isAuthenticated: false,
  user: {},
  loading: false
};

// eslint-disable-next-line
export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload
      };
    case USER_LOADING:
      return {
        ...state,
        loading: true
      };
    case EDIT_USER:
    return{
      ...state,
      user: action.payload
    }
    default:
      return state;
  }
}
